import { render, staticRenderFns } from "./PageAccessSSO.vue?vue&type=template&id=7d23b826&scoped=true&"
import script from "./PageAccessSSO.vue?vue&type=script&lang=js&"
export * from "./PageAccessSSO.vue?vue&type=script&lang=js&"
import style0 from "./PageAccessSSO.vue?vue&type=style&index=0&id=7d23b826&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d23b826",
  null
  
)

export default component.exports